import React, { useState } from 'react';

export default function Modals({ 
  activeModal, 
  setActiveModal, 
  showToast, logout, 
  setCurrentView, 
  profile, 
  onConnect 
}) { // Added profile here 
  
  const [connectNote, setConnectNote] = useState('');
  
  // Local state for interactive modal elements
  const [storyTimer, setStoryTimer] = useState('6h');
  const [filterCreativity, setFilterCreativity] = useState(4);
  const [filterDelivery, setFilterDelivery] = useState(3);
  const [filterComms, setFilterComms] = useState(4);
  const [filterOverall, setFilterOverall] = useState(4);

  // Helper to close modals easily
  const closeModal = () => setActiveModal(null);

  // Helper to handle sharing
  const doShare = (platform) => {
    closeModal();
    showToast(platform === 'Buniverse' ? 'Shared within Buniverse' : `Opening ${platform} to share...`);
  };

  return (
    <>
      {/* SHARE MODAL */}
      <div className={`modal-bg ${activeModal === 'share-modal' ? 'open' : ''}`}>
        <div className="modal">
          <div className="modal-title">Share profile</div>
          <div className="modal-sub">Share @amara.creates within Buniverse or to your socials.</div>
          <div className="share-opt" onClick={() => doShare('Buniverse')}><div className="share-opt-icon" style={{ background: 'var(--purple-l)' }}>📩</div><div><div className="share-opt-label">Share within Buniverse</div><div className="share-opt-desc">Send to a connection</div></div></div>
          <div className="share-opt" onClick={() => doShare('Instagram')}><div className="share-opt-icon" style={{ background: 'var(--coral-l)' }}>📷</div><div><div className="share-opt-label">Instagram</div></div></div>
          <div className="share-opt" onClick={() => doShare('WhatsApp')}><div className="share-opt-icon" style={{ background: 'var(--teal-l)' }}>💬</div><div><div className="share-opt-label">WhatsApp</div></div></div>
          <div className="share-opt" onClick={() => doShare('X')}><div className="share-opt-icon" style={{ background: 'var(--blue-l)' }}>🐦</div><div><div className="share-opt-label">X / Twitter</div></div></div>
          <div style={{ fontSize: '10px', color: 'var(--text3)', margin: '10px 0 5px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.05em' }}>Copy link</div>
          <div className="link-row">
            <input type="text" value="buniverse.io/amara.creates" readOnly />
            <button className="copy-btn" onClick={() => showToast('Link copied!')}>Copy</button>
          </div>
          <button className="modal-cancel" onClick={closeModal}>Cancel</button>
        </div>
      </div>

      {/* CONNECT MODAL */}
      <div className={`modal-bg ${activeModal === 'connect-modal' ? 'open' : ''}`}>
        <div className="modal">
          <div className="modal-title">Connect with {profile?.display_name || 'User'}</div>
          <div className="modal-sub">{profile?.display_name || 'They'} must accept before you're mutually connected.</div>
          <div className="status-card">Your request will appear in {profile?.display_name || 'their'} notifications.</div>
          <textarea 
          className="connect-note" 
          placeholder="Add a short note (optional)"
          value={connectNote}
          onChange={(e) => setConnectNote(e.target.value)}
          ></textarea>
          
          <div className="btn-row">
            <button 
              className="btn-cancel" 
              onClick={closeModal}
              >Cancel
            </button>

            {/* UPDATED BUTTON HERE */}
            <button 
              className="btn-send" 
              onClick={() => {
                if (onConnect) {
                  onConnect(connectNote); // Pass the note here!
                } else {
                  showToast('Connection request sent'); 
                  closeModal(); 
                }
                setConnectNote(''); // Reset after sending
              }}
            >
              Send request
            </button>
            
          </div>
        </div>
      </div>

      {/* UPGRADE MODAL */}
      <div className={`modal-bg ${activeModal === 'upgrade-modal' ? 'open' : ''}`}>
        <div className="modal">
          <div className="modal-title">Upgrade your plan</div>
          <div className="modal-sub">Unlock unlimited platforms, AI tools, booking calendar and more.</div>
          <div className="plan-option featured" onClick={() => { showToast('Upgraded to Mid plan!'); closeModal(); }}>
            <div className="po-name">Mid plan <span style={{ fontSize: '9px', background: 'var(--purple)', color: '#fff', borderRadius: '99px', padding: '2px 7px', fontFamily: "'Syne', sans-serif" }}>Popular</span></div>
            <div className="po-price">$9/mo</div>
            <div className="po-feats">✓ Unlimited platforms · ✓ Booking · ✓ Analytics</div>
          </div>
          <div className="plan-option" onClick={() => { showToast('Upgraded to Premium plan!'); closeModal(); }}>
            <div className="po-name">Premium plan</div>
            <div className="po-price">$25/mo</div>
            <div className="po-feats">✓ Everything + Full AI suite · ✓ Scout boost</div>
          </div>
          <button className="modal-cancel" onClick={closeModal}>Maybe later</button>
        </div>
      </div>


      {/* USER MODAL */}
      <div className={`modal-bg ${activeModal === 'user-modal' ? 'open' : ''}`}>
        <div className="modal" style={{ width: '300px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
            
            {/* Dynamic Avatar */}
            <div className="user-av" style={{ fontSize: '20px', width: '50px', height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', background: 'var(--purple-l)', color: 'var(--purple)' }}>
             {profile?.avatar_url ? (
                <img src={profile.avatar_url} alt="Avatar" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : (
                profile ? profile.display_name.charAt(0).toUpperCase() : '?'
              )}
            </div>
            
            {/* Dynamic Name and Handle */}
            <div>
              <div id="modal-user-name" style={{ fontWeight: 600 }}>
                {profile?.display_name || 'Loading...'}
              </div>
              <div id="modal-user-handle" style={{ fontSize: '12px', color: 'var(--ink3)' }}>
                @{profile?.handle || 'loading'}
              </div>
            </div>
          </div>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <button className="btn-ghost" onClick={() => { setCurrentView('profile'); closeModal(); }}>View Profile</button>
            <button className="btn-ghost" onClick={() => { setCurrentView('settings'); closeModal(); }}>Account Settings</button>
            <div style={{ height: '1px', background: 'var(--border)', margin: '8px 0' }}></div>
            <div className="btn-row">
              <button className="btn-send" style={{ marginTop: '20px' }} onClick={logout}>Logout</button>
              <button className="btn-cancel" style={{ marginTop: '20px' }} onClick={closeModal}>Close</button>    
            </div>
          </div>
        </div>
      </div>

      {/* STORY UPLOAD MODAL */}
      <div className={`modal-bg ${activeModal === 'story-upload-modal' ? 'open' : ''}`}>
        <div className="modal">
          <div className="story-modal-av">🎨</div>
          <div className="modal-title" style={{ textAlign: 'center' }}>Add a story</div>
          <div className="modal-sub" style={{ textAlign: 'center' }}>Stories disappear after the selected time.</div>
          <div className="upload-area" style={{ marginBottom: '1rem' }} onClick={() => showToast('Media picker coming soon')}>
            <div style={{ fontSize: '22px', marginBottom: '6px' }}>📸</div>
            <div style={{ fontSize: '11px', color: 'var(--text3)' }}>Tap to upload photo or video</div>
          </div>
          <div style={{ fontSize: '11px', color: 'var(--text2)', marginBottom: '8px', fontWeight: 600 }}>Story expires after</div>
          <div className="story-timer-select">
            {['1h', '6h', '12h', '24h'].map(time => (
              <div key={time} className={`sts-opt ${storyTimer === time ? 'active' : ''}`} onClick={() => setStoryTimer(time)}>
                {time === '1h' ? '1 hour' : `${time.replace('h', '')} hours`}
              </div>
            ))}
          </div>
          <div className="btn-row">
            <button className="btn-cancel" onClick={closeModal}>Cancel</button>
            <button className="btn-send" onClick={() => { showToast('Story posted!'); closeModal(); }}>Post story</button>
          </div>
        </div>
      </div>

      {/* BLOCK MODAL */}
      <div className={`modal-bg ${activeModal === 'block-modal' ? 'open' : ''}`}>
        <div className="modal">
          <div className="modal-title">Block user</div>
          <div className="modal-sub">Are you sure you want to block this user? They won't be able to view your profile, follow you, or interact with your content.</div>
          <div className="warn-card">Blocked users can submit a written appeal to you. You are not required to respond.</div>
          <div className="btn-row">
            <button className="btn-cancel" onClick={closeModal}>Cancel</button>
            <button className="btn-send" style={{ background: 'var(--coral)' }} onClick={() => { showToast('User blocked'); closeModal(); }}>Block user</button>
          </div>
        </div>
      </div>

      {/* VERIFY MODAL */}
      <div className={`modal-bg ${activeModal === 'verify-modal' ? 'open' : ''}`}>
        <div className="modal verify-content">
          <div className="modal-title">✦ Get verified</div>
          <div className="modal-sub">Verified accounts get higher visibility, a badge, and priority placement.</div>
          <div className="tier"><div className="tier-name">Creative verified <span className="tier-badge" style={{ background: 'var(--blue-l)', color: 'var(--blue)' }}>✦ Blue</span></div><div className="tier-desc">Complete profile, 10+ works, rating 4.0+. Free to apply.</div></div>
          <div className="tier"><div className="tier-name">Industry verified <span className="tier-badge" style={{ background: 'var(--amber-l)', color: 'var(--amber)' }}>★ Gold</span></div><div className="tier-desc">For scouts, labels, studios and agencies. Requires business docs.</div></div>
          <div className="tier"><div className="tier-name">Press verified <span className="tier-badge" style={{ background: 'var(--teal-l)', color: 'var(--teal)' }}>✎ Teal</span></div><div className="tier-desc">For journalists covering the creative industry.</div></div>
          <button className="btn-send" style={{ width: '100%', marginTop: '8px' }} onClick={() => { showToast('✦ Verification application submitted'); closeModal(); }}>Apply for verification</button>
          <button className="modal-cancel" onClick={closeModal}>Maybe later</button>
        </div>
      </div>

      {/* CUSTOM FILTER MODAL */}
      <div className={`modal-bg ${activeModal === 'custom-filter-modal' ? 'open' : ''}`}>
        <div className="modal">
          <div className="modal-title">⚙ Custom profile filter</div>
          <div className="modal-sub">Set minimum rating thresholds. Only matching creatives appear in your feed.</div>
          
          <div className="cf-row"><div className="cf-attr">Creativity</div><input type="range" className="cf-slider" min="1" max="5" value={filterCreativity} onChange={(e) => setFilterCreativity(e.target.value)} /><div className="cf-val">{filterCreativity}</div></div>
          <div className="cf-row"><div className="cf-attr">Delivery</div><input type="range" className="cf-slider" min="1" max="5" value={filterDelivery} onChange={(e) => setFilterDelivery(e.target.value)} /><div className="cf-val">{filterDelivery}</div></div>
          <div className="cf-row"><div className="cf-attr">Communication</div><input type="range" className="cf-slider" min="1" max="5" value={filterComms} onChange={(e) => setFilterComms(e.target.value)} /><div className="cf-val">{filterComms}</div></div>
          <div className="cf-row"><div className="cf-attr">Overall</div><input type="range" className="cf-slider" min="1" max="5" value={filterOverall} onChange={(e) => setFilterOverall(e.target.value)} /><div className="cf-val">{filterOverall}</div></div>
          
          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', margin: '10px 0' }}>
            <div className="chip active">✦ Verified only</div>
            <div className="chip active">Open to work</div>
            <div className="chip">Min 50 reviews</div>
          </div>
          <div className="btn-row">
            <button className="btn-cancel" onClick={closeModal}>Cancel</button>
            <button className="btn-send" onClick={() => { showToast('Custom filter saved'); closeModal(); }}>Save filter</button>
          </div>
        </div>
      </div>
    </>
  );
}